import { TimeUnit } from '~/basket/model/common/duration.model'
import { Price } from '~/basket/model/common/price.model'

const holder = {
  value: 0,
  duration: {
    unit: TimeUnit.MONTH,
    amount: 0,
  },
  taxIncluded: false,
}

function reducePricesByDuration(pricesArr: Price[]) {
  const pricesReduced = pricesArr.reduce(
    (curr, next) => {
      const currentAmount = next.duration.amount
      const priceSameDuration = curr.find((elem) => elem.duration.amount === currentAmount)
      if (!priceSameDuration) {
        return [...curr, next]
      }
      const pricesDurationAdded = {
        ...priceSameDuration,
        value: priceSameDuration.value + next.value,
      }
      const index = curr.indexOf(priceSameDuration)
      // eslint-disable-next-line no-param-reassign
      curr[index] = pricesDurationAdded
      return curr
    },
    [holder],
  )

  return pricesReduced.filter((elem) => elem.value !== 0)
}

function sumPrices(pricesArr: Price[]) {
  const pricesSum = pricesArr.map((elem, i, arr) => {
    let summed = elem
    arr.forEach((elemnt) => {
      if (elem.duration.amount === 0) return elem
      if (elem.duration.amount < elemnt.duration.amount || elemnt.duration.amount === 0) {
        summed = {
          ...elem,
          value: summed.value + elemnt.value,
        }
      }
      return summed
    })
    return summed
  })

  return pricesSum
}

function substractDurations(pricesArr: Price[]) {
  const sorted = pricesArr.sort((a, b) => {
    return a.duration.amount - b.duration.amount
  })
  let arr = sorted
  if (sorted.length && sorted[0].duration.amount === 0) {
    const [first, ...rest] = sorted
    arr = [...rest, first]
  }
  return arr.map((price, i, arr) => {
    if (arr.length === 1 || i === 0 || price.duration.amount === 0) return price
    const nextPriceDuration = arr[i - 1].duration.amount
    const amount = price.duration.amount - nextPriceDuration
    return { ...price, duration: { ...price.duration, amount } }
  })
}

export function addTaxToPriceRounded(pricesArr: Price[], tax: number) {
  return pricesArr.map((price) => ({
    ...price,
    value: price.taxIncluded ? +price.value.toFixed(2) : +(price.value * tax).toFixed(2),
    taxIncluded: price.taxIncluded ? price.taxIncluded : true,
  }))
}

export function formatPrices(pricesArr: Price[], tax: number) {
  const addedTaxes = addTaxToPriceRounded(pricesArr, tax)
  const reducedByDuration = reducePricesByDuration(addedTaxes)
  const summedPrices = sumPrices(reducedByDuration)
  return substractDurations(summedPrices)
}

export function formatPriceStr(value: number) {
  return value.toFixed(2).toString().replace('.', ',')
}

export function formatStr(pricesArr: Price[]) {
  return pricesArr.map(({ value, duration: { amount } }, i, arr) => {
    const price = value < 0 ? value * -1 : value
    const isOnlyPrice = arr.length === 1 && amount === 0
    const priceObj = {
      duration: '',
      payment: `${formatPriceStr(price)}€/mes${isOnlyPrice ? '.' : ''}`,
      pretext: '',
    }

    if (isOnlyPrice) return priceObj

    if (i === 0) {
      return {
        ...priceObj,
        duration: ` durante ${amount} meses${arr.length === 1 ? '.' : ', '}`,
      }
    }
    if (i === arr.length - 1) {
      return {
        ...priceObj,
        payment: `${formatPriceStr(price)}€/mes.`,
        pretext: 'después ',
      }
    }

    return {
      ...priceObj,
      pretext: ` los ${amount} meses siguientes `,
    }
  })
}

export function flatten(prices: Price[][]) {
  return prices.reduce((a: Price[], b: Price[]) => a.concat(b), [])
}

export function formatPriceMonthToMonth(prices: Price[]) {
  let months = 0
  return prices.map(({ value, duration: { amount } }, i, arr) => {
    const price = {
      amount: formatPriceStr(value),
      duration: `Del mes ${months + 1}º al ${months + amount}º`,
    }
    if (amount === 0) {
      price.duration = 'Después'
    }
    if (i === 0) {
      price.duration = `Del mes 1º al ${amount}º`
    }
    if (amount === 1) {
      price.duration = `El mes ${months + 1}º`
    }
    if (arr.length === 1) {
      price.duration = ''
    }
    months += amount
    return price
  })
}
